import { faDownToLine } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Menu, MenuItem } from '@mui/material';
import {
  bindMenu,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks';

import type { ExportButtonV2Props } from './ExportButtonV2.types';

enum ExportTypes {
  CSV = 'csv',
  JSON = 'json'
}

export const ExportButtonV2 = ({
  handleClick,
  buttonIcon = faDownToLine,
  buttonLabel = 'Export',
  json,
  csv,
  variant = 'outlined'
}: ExportButtonV2Props) => {
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'exportMenu'
  });

  if (!csv && !json) return null;

  // If only one export format is enabled, export directly without showing menu
  const singleFormatOnly = (csv && !json) || (!csv && json);

  return (
    <>
      <Button
        variant={variant}
        startIcon={<FontAwesomeIcon size="lg" icon={buttonIcon} />}
        {...(singleFormatOnly
          ? {
              onClick: () =>
                handleClick(csv ? ExportTypes.CSV : ExportTypes.JSON)
            }
          : bindTrigger(popupState))}
        disabled={!handleClick}
      >
        {buttonLabel}
      </Button>
      {!singleFormatOnly && (
        <Menu {...bindMenu(popupState)}>
          {csv && (
            <MenuItem
              onClick={() => {
                handleClick(ExportTypes.CSV);
                popupState.close();
              }}
            >
              CSV Format
            </MenuItem>
          )}
          {json && (
            <MenuItem
              onClick={() => {
                handleClick(ExportTypes.JSON);
                popupState.close();
              }}
            >
              JSON Format
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
};

export default ExportButtonV2;
